export const environment = {
  production: false,
  user_service: 'https://hs-test-api.comexis.net/',
};
